import { cn } from "@/lib/utils";
import { Search, SlidersHorizontal } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export const SearchBar = ({ 
  placeholder = 'Search...',
  value,
  onChange,
  onFilterClick,
  showFilter = false,
  className 
}) => {
  return (
    <div 
      className={cn("flex items-center gap-3", className)}
      data-testid="search-bar"
    >
      <div className="relative flex-1">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-text" />
        <Input
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          className={cn(
            "pl-10 bg-graphite border-white/[0.06] text-cloud-white",
            "placeholder:text-muted-text focus:border-electric-ice-blue/50",
            "rounded-lg h-10"
          )}
          data-testid="search-input"
        />
      </div>
      
      {showFilter && (
        <Button
          variant="outline"
          size="icon"
          onClick={onFilterClick}
          className="border-white/[0.06] hover:bg-white/[0.05] h-10 w-10"
          data-testid="filter-trigger"
        >
          <SlidersHorizontal className="w-4 h-4 text-soft-silver" />
        </Button>
      )}
    </div>
  );
};

export default SearchBar;
